import { mapGetters } from 'vuex'

export const computed = {
  ...mapGetters('user', ['authUser', 'hoaId', 'authUserType']),
  ownerID() {
    return this.authUser.ownerID
  }
}
